import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import { useI18n } from '@modules/i18n/composables';
import { TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

import {
  ADMIN_WELL_KNOWN_LINKS_ROUTE_NAME,
  TRANSLATION_GROUP_ADMIN_WELL_KNOWN_LINKS,
  WELL_KNOWN_LINKS_PERMISSIONS,
} from './constants';
import getTranslationKeys from './translations';

export class WellKnownLinksModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_WELL_KNOWN_LINKS_ROUTE_NAME,
      path: 'well-known-links',
      component: () => import('@modules/well-known-links/pages/WellKnownLinksPage/WellKnownLinksPage.vue'),
      permission: [
        WELL_KNOWN_LINKS_PERMISSIONS.SHOW,
        WELL_KNOWN_LINKS_PERMISSIONS.EDIT,
      ],
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'GENERAL_SETTINGS_WELL_KNOWN_LINKS'),
      to: {
        name: ADMIN_WELL_KNOWN_LINKS_ROUTE_NAME,
      },
      id: ADMIN_WELL_KNOWN_LINKS_ROUTE_NAME,
      permission: [
        WELL_KNOWN_LINKS_PERMISSIONS.SHOW,
        WELL_KNOWN_LINKS_PERMISSIONS.EDIT,
      ],
      order: 160,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_ADMIN_WELL_KNOWN_LINKS, getTranslationKeys);
  }
}
